function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "data",
  transform: "translate(1.000000, 5.282609)",
  stroke: "#666666"
}, React.createElement("line", {
  x1: 7,
  y1: 6.7173913,
  x2: 4,
  y2: 9.7173913,
  id: "Line_50"
}), React.createElement("line", {
  x1: 19,
  y1: 4.7173913,
  x2: 16.5,
  y2: 7.2173913,
  id: "Line_51"
}), React.createElement("line", {
  x1: 13,
  y1: 7.7173913,
  x2: 10,
  y2: 5.7173913,
  id: "Line_52"
}), React.createElement("circle", {
  id: "Ellipse_40",
  cx: 2,
  cy: 11.7173913,
  r: 2
}), React.createElement("circle", {
  id: "Ellipse_41",
  cx: 8,
  cy: 4.7173913,
  r: 2
}), React.createElement("circle", {
  id: "Ellipse_42",
  cx: 15,
  cy: 8.7173913,
  r: 2
}), React.createElement("circle", {
  id: "Ellipse_43",
  cx: 20,
  cy: 2.7173913,
  r: 2
})));

function SvgData(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+Cjxzdmcgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJkYXRhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgNS4yODI2MDkpIiBzdHJva2U9IiM2NjY2NjYiPgogICAgICAgICAgICA8bGluZSB4MT0iNyIgeTE9IjYuNzE3MzkxMyIgeDI9IjQiIHkyPSI5LjcxNzM5MTMiIGlkPSJMaW5lXzUwIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSIxOSIgeTE9IjQuNzE3MzkxMyIgeDI9IjE2LjUiIHkyPSI3LjIxNzM5MTMiIGlkPSJMaW5lXzUxIj48L2xpbmU+CiAgICAgICAgICAgIDxsaW5lIHgxPSIxMyIgeTE9IjcuNzE3MzkxMyIgeDI9IjEwIiB5Mj0iNS43MTczOTEzIiBpZD0iTGluZV81MiI+PC9saW5lPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzQwIiBjeD0iMiIgY3k9IjExLjcxNzM5MTMiIHI9IjIiPjwvY2lyY2xlPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzQxIiBjeD0iOCIgY3k9IjQuNzE3MzkxMyIgcj0iMiI+PC9jaXJjbGU+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNDIiIGN4PSIxNSIgY3k9IjguNzE3MzkxMyIgcj0iMiI+PC9jaXJjbGU+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNDMiIGN4PSIyMCIgY3k9IjIuNzE3MzkxMyIgcj0iMiI+PC9jaXJjbGU+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgData as ReactComponent };